export enum OpenApiSpecActionType {
  GetOpenApiSpec = '@quidproquo-core/OpenApiSpec/GetOpenApiSpec',
}
